import {
  BooleanField,
  DateField,
  Loading,
  NumberField,
  Show,
  SimpleShowLayout,
  TextField,
  useGetOne,
  useRedirect,
} from 'react-admin';
import { useParams } from 'react-router-dom';
import { AdminPromocodeResponseDto } from 'shared/api';
import { LABELS } from 'shared/constants/labels';

export const PromocodeShow = () => {
  const { id } = useParams<{ id: any }>();
  const redirect = useRedirect();

  const { data: promocodeData, isLoading: isPromocodeLoading, error: promocodeError } = useGetOne<AdminPromocodeResponseDto>(
    'promocodes',
    { id },
    { onError: () => redirect('/patients') },
  );

  if (isPromocodeLoading) {
    return <Loading />;
  }

  if (promocodeError) {
    return (
      <p>
        Произошла ошибка при загрузке данных:
      </p>
    );
  }

  if (!promocodeData) {
    return <p>Данные отсутствуют.</p>;
  }

  const pageTitle = `Промокод ${promocodeData.code}`;

  return (
    <Show title={pageTitle}>
      <SimpleShowLayout>
        <TextField source="id" label={LABELS.promocodeId} />
        <TextField source="discountType" label={LABELS.promocodeType} />
        <TextField source="code" label={LABELS.promocodeCode} />
        <NumberField source="amount" label={LABELS.promocodeAmount} />
        <NumberField source="percentage" label={LABELS.promocodePercentage} />
        <DateField source="expireDate" label={LABELS.promocodeExpireDate} />
        <BooleanField source="firstUseOnly" label={LABELS.promocodeFirstUseOnly} />
        <NumberField source="timesUsed" label={LABELS.promocodeTimesUsed} />
        <NumberField source="useLimitPerUser" label={LABELS.promocodeLimitPerUser} />
        <TextField source="companyName" label={LABELS.companyName} />
        <TextField source="consumerEmail" label={LABELS.promocodeConsumerEmail} />
        <DateField source="createdAt" label={LABELS.createdAt} />
        <TextField source="adminName" label={LABELS.promocodeCreatorName} />
      </SimpleShowLayout>
    </Show>
  );
};